<template>
	<div style="display: flex;">
		<div class="midlle">
			
			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">进行中的订单</div>
				</div>
				<div v-if="false">
					<div style="display:flex;align-items: center;justify-content: space-between;padding: 0 15px;margin-bottom: 10px;">
						<div style="display:flex;align-items: center;">
							<div class="select-out">
								<el-select v-model="value" id="selectInp" style="" placeholder="全部类型">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
							<div style="display: flex;align-items: baseline;cursor: pointer;margin-left: 15px;">
								时间<img src="../../assets/images/shaixuan.png" alt="" style="width: 15px;height: 13px;">
							</div>
						</div>
						<el-checkbox-group v-model="checkedOrder">
							<el-checkbox v-for="item in orderStatusList" :label="item" :key="item">{{ item }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<el-table :data="tableData" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="num" label="编号" width="73" :resizable="false">
						</el-table-column>
						<el-table-column prop="type" label="类别" width="79" :resizable="false">
						</el-table-column>
						<el-table-column prop="title" label="标题" width="125" :resizable="false">
						</el-table-column>
						<el-table-column  label="对接销售" width="120" :resizable="false">
							<template slot-scope="scope">
								<el-select v-model="scope.row.sales.selected.name" @change="changSales" style="" placeholder="尚未分配">
									<el-option v-for="item in scope.row.sales.peopel" :key="item.value" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column  label="状态" width="68" :resizable="false">
							<template slot-scope="scope">
									{{scope.status == 1 ?'已下单':'已互评'}}
							</template>
						</el-table-column>
						<el-table-column prop="date" label="当前状态开始时间" width="100" :resizable="false">
					
						</el-table-column>
					
						<el-table-column label="当前状态用户" width="90" :resizable="false">
							<template slot-scope="scope">
								<div>
									<p v-for="(item,index) in scope.row.name">
										{{item}}
									</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column  label="查看详情" width="80" :resizable="false">
							<div class="link" style="color: #0052D9 !important;">查看详情</div>
						</el-table-column>
						<el-table-column label="备注" width="83" :resizable="false">
							<template slot-scope="scope">
								<p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">
								{{scope.row.beizhu}}
								</p>
							</template>
						</el-table-column>
					
					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>

			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">我的产品与服务</div>
				</div>
				<div v-if="false">
					<el-table :data="tableData2" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="num" label="编号" width="91" :resizable="false">
						</el-table-column>
					
						<el-table-column prop="title" label="名称" width="146" :resizable="false">
						</el-table-column>
					
						<el-table-column prop="date" label="公布时间" width="140" :resizable="false">
						</el-table-column>
						<el-table-column prop="view" label="查看" width="76" :resizable="false">
					
						</el-table-column>
						<el-table-column prop="shouC" label="收藏" width="75" :resizable="false">
						
						</el-table-column>
						<el-table-column prop="like" label="喜欢" width="75" :resizable="false">
						
						</el-table-column>
						<el-table-column prop="deal" label="成交" width="75" :resizable="false">
						
						</el-table-column>
						<el-table-column label="当前状态" width="140" :resizable="false">
						<template slot-scope="scope">
							<p style="display: flex;align-items: center;justify-content: space-around;">
								<span>{{scope.row.status == 1? '网站精选':'热门推荐'}}</span>|<span>更改</span></p>
						</template>
						</el-table-column>
					
					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">我的平台活动</div>
				</div>
				<div v-if="false">
					<div style="display:flex;align-items: center;justify-content: space-between;padding: 0 15px;margin-bottom: 10px;">
						<div style="display:flex;align-items: center;">
							<el-select v-model="value" id="selectInp" style="" placeholder="全部类型">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<div style="display: flex;align-items: baseline;cursor: pointer;margin-left: 15px;">
								时间<img src="../../assets/images/shaixuan.png" alt="" style="width: 15px;height: 13px;">
							</div>
						</div>
						<el-checkbox-group v-model="checkedCities">
							<el-checkbox v-for="city in cities6" :label="city" :key="city">{{ city }}</el-checkbox>
						</el-checkbox-group>
					</div>
					<el-table :data="tableData3" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="type" label="类型" width="105" :resizable="false">
						</el-table-column>
						<el-table-column prop="type" label="类别" width="75" :resizable="false">
							<div class="pointer">
								<p>发布</p>
								<p>收藏</p>
								<p>点赞</p>
							</div>
						</el-table-column>
						<el-table-column prop="title" label="标题" width="150" :resizable="false">
						</el-table-column>
						<el-table-column prop="status" label="状态" width="87" :resizable="false">
						</el-table-column>
						<el-table-column prop="date" label="当前状态开始时间" width="132" :resizable="false">
						</el-table-column>
						<el-table-column prop="name" label="当前状态用户" width="130" :resizable="false">
						</el-table-column>
					
						<el-table-column label="查看详情" width="140" :resizable="false">
							<div class="link" style="color: #0052D9 !important;">
								详情链接
							</div>
						</el-table-column>
					
					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200" ></el-empty>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	const cityOptions6 = ['发布', '收藏', '点赞'];
	const orderStatus = ['咨询中', '已下单', '已登记','全部订单'];
	export default {
		data() {
			return {
				cities6: cityOptions6,
				orderStatusList: orderStatus,
				checkedCities: [],
				checkedOrder: [],
				tableData: [{
						num:'202366',
						type: '项目课题',
						title: 'AI只能软件开发',
						status: '已公布',
						date: '2016-05-02',
						name: ['王先生', '王小虎'],
						link: '详情链接',
						id: 1,
						beizhu:'zcawasdzvsadqwfdbm1qzxc123123123',
						status:1,
						sales:{
							selected:{
								name:'小李',
								id:6
							},
							peopel:[
								{
									name:'小林',
									id:1
								},
								{
									name:'小杜',
									id:2
								}
							]
						}
					},
				],
				tableData2: [{
					num: 'qw1065',
					title: 'AI只能软件开发',
					date: '2016-05-02',
					view:100,
					shouC:120,
					like:10,
					deal:100,
					status:2,
					id:5
				}],
				tableData3: [{
					type: '项目课题',
					title: 'AI只能软件开发',
					date: '2016-05-02',
					status: '已公布',
					name: ['王先生,', '王小虎'],
					link: '详情链接',
					id: 1
				}],
				//工作领域 1 select
				options1s: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value1s: '',
				// 下拉框

				options: [{
					value: '选项1',
					label: '项目'
				}, {
					value: '选项2',
					label: '资源'
				}, {
					value: '选项3',
					label: '方案'
				}, {
					value: '选项4',
					label: '产品'
				}, {
					value: '选项5',
					label: '人才'
				}],
				value: '',
			}
		},
		methods: {
			changSales(e){
				console.log(e);
			},
			handleChange(val) {
				console.log(val);
			},
			cc(row, column, cell, event) {
				console.log(row, column.label, cell, event);
			},
		}
	}
</script>
<style>
	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #0052D9;
		border-color: #0052D9;
	}
	 .el-input__inner::placeholder{
		 color: #222;
	 }
	 .el-input__inner{
		 background: none;
		 color: #222;
	 }
	.select-out .el-input__inner{
		width: 150px;
	}
	.el-checkbox__input.is-checked+.el-checkbox__label{
		color: #0052D9;
	}
</style>
<style scoped lang="less">
	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}

	.table {
		.table-item {
			align-items: center;
			display: flex;
			padding: 0 20px;
			justify-content: space-between;
			height: 55px;

		}

	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	.midlle-body {
		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		margin-bottom: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		background: white;
	}

	.midlle {
		width: 860px;
		padding: 0 20px;
		box-sizing: border-box;

		.midller-top {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.top-item {
				.clounm {
					margin-top: 15px;
					display: flex;

					.title {
						font-weight: bold;

						.justi {
							display: inline-block;
							text-align-last: justify;
							text-align: justify;
							width: 65px;
						}
					}
				}

				font-size: 16px;

				.header {
					display: flex;
					justify-content: space-between;
				}

				padding: 20px 0 20px 20px;
				box-sizing: border-box;
				width: 400px;
				height: 205px;
				background: #FFFFFF;
			}
		}
	}
</style>